import { fixedUi } from '@/i18n/fixedUi';
import React, { useEffect, useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import AgencyCompaniesPanel from '@/shein-platform/modules/compliance/AgencyCompaniesPanel';
import EnvironmentalMaterialsPanel from '@/shein-platform/modules/compliance/EnvironmentalMaterialsPanel';
import { buildSheinTemplateChildPath } from '@/shein-platform/constants/sheinRoutes';
import '@/styles/shein-platform/shein-product-ops.css';

const DIM_LIBRARY = 'library';
const DIM_AGENCY = 'agency';
const DIM_ENV = 'environmental';

/** 合规资料二维共用：切维度时进度不落到全局顶栏 */
const MATERIALS_SYNC_KINDS = ['agency', 'environmental'];

const DIM_TABS = [
  { id: DIM_AGENCY, label: '公司代理' },
  { id: DIM_ENV, label: '环保耗材' },
];

function resolveDim(raw) {
  if (raw === DIM_ENV || raw === 'env' || raw === 'environmental') return DIM_ENV;
  return DIM_AGENCY;
}

export default function ComplianceMaterialsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawDim = searchParams.get('dim');
  const dimFromUrl = resolveDim(rawDim);
  const [dim, setDim] = useState(dimFromUrl);

  useEffect(() => {
    setDim(dimFromUrl);
  }, [dimFromUrl]);

  if (rawDim === DIM_LIBRARY) {
    return <Navigate to={buildSheinTemplateChildPath('certificates')} replace />;
  }

  const switchDim = (next) => {
    setDim(next);
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('dim', next);
    setSearchParams(nextParams, { replace: true });
  };

  return (
    <div className="spo-dim-page">
      <div className="spo-status-tabs spo-dim-tabs" role="tablist" aria-label={fixedUi("合规资料维度")}>
        {DIM_TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={dim === tab.id}
            className={`spo-status-tab${dim === tab.id ? ' spo-status-tab--active' : ''}`}
            onClick={() => switchDim(tab.id)}
          >
            {fixedUi(tab.label)}
          </button>
        ))}
      </div>
      <div
        className="spo-dim-page__panel"
        hidden={dim !== DIM_AGENCY}
        aria-hidden={dim !== DIM_AGENCY}
      >
        <AgencyCompaniesPanel syncKinds={MATERIALS_SYNC_KINDS} />
      </div>
      <div
        className="spo-dim-page__panel"
        hidden={dim !== DIM_ENV}
        aria-hidden={dim !== DIM_ENV}
      >
        <EnvironmentalMaterialsPanel syncKinds={MATERIALS_SYNC_KINDS} />
      </div>
    </div>
  );
}
